import React, { useEffect, useState } from "react";
import { IoSettingsOutline, IoNotificationsOffSharp } from "react-icons/io5";
import { MdOutlinePayment } from "react-icons/md";
import { IoMdStarOutline } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import { CiDiscount1 } from "react-icons/ci";
import { NavLink } from "react-router-dom";
import { TbCategory } from "react-icons/tb";
import { MdOutlineInventory2 } from "react-icons/md";
import { IoHomeOutline } from "react-icons/io5";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import { CiMail } from "react-icons/ci";
// import SidebarLogo from "../Image/SideBarIcon.png";
import SidebarLogo from "../../Image/compwebinarlogo.png";
import { CiShoppingBasket } from "react-icons/ci";
import { FaGreaterThan } from "react-icons/fa";
import { VscAccount } from "react-icons/vsc";
import { TbPointFilled } from "react-icons/tb";
import { Collapse } from "antd";
import "./SideBar.css";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";

import {
  getRandomColor,
  createImageFromInitials,
} from "../../controllers/common";
import { ASSETS_BASE_URL } from "../../config/constants";

const { Panel } = Collapse;

const SidebarItem = ({ to, icon, name, isOpen, className }) => (
  <NavLink to={to} className={`link ${className}`} activeClassName="active">
    <div className="icon">{icon}</div>
    <div style={{ display: isOpen ? "block" : "none" }} className="link_text">
      {name}
    </div>
  </NavLink>
);

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const handleCollapseToggle = () => {
    setIsOpen(!isOpen);
  };
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const [USERDATA, setUserData] = useState(user || "");

  
  const [PERMISSIONDATA, setPermissionData] = useState('');

  useEffect(()=>{
    if(sessionStorage.getItem("ADMIN-PERMISSION") !== 'undefined'){
      const permission = JSON.parse(sessionStorage.getItem("ADMIN-PERMISSION"));
      setPermissionData(permission);
    }
  },[])

  return (
    <div
      className={`container-fluid side_bar_main_div ${
        isOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <div
        style={{ width: isOpen ? "300px" : "70px", position: "relative " }}
        className="sidebar"
      >
        <div className="top_section">
          <img
            src={SidebarLogo}
            className="sidebar_logo"
            alt="Logo"
            style={{
              display: isOpen ? "block" : "none",
              height: "90px",
              width: "auto",
            }}
          />
          <div
            className="bars"
          >
            <RiBarChartHorizontalLine onClick={handleCollapseToggle} />
          </div>
        </div>
        <div className="my_sidebar_all_section">
          <SidebarItem
            to="/dashboard"
            icon={<IoHomeOutline />}
            name="Dashboard"
            isOpen={isOpen}
          />
          {/* <React.Fragment>
          {(PERMISSIONDATA?.accounts?.user === 'Y' || PERMISSIONDATA?.accounts?.vendor === 'Y' || user?.admin_type === 'Super Admin') && (
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <VscAccount className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Accounts </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {user?.admin_type === 'Super Admin' &&(
                  <SidebarItem to="/sub-admin/list" icon={<TbPointFilled />} name="Sub Admin" isOpen={isOpen} />
                )}
                {(PERMISSIONDATA?.accounts?.user === 'Y' || user?.admin_type === 'Super Admin') && (
                  <SidebarItem to="/users/list" icon={<TbPointFilled />} name="Users" isOpen={isOpen}/>
                )}
                {(PERMISSIONDATA?.accounts?.vendor === 'Y' || user?.admin_type === 'Super Admin') && (
                  <SidebarItem to="/vendors/list" icon={<TbPointFilled />} name="Vendors" isOpen={isOpen}/>
                )}
              </Panel>
            </Collapse>
          )}
          </React.Fragment> */}

          {/* {(
            PERMISSIONDATA?.category?.product === 'Y' || 
            PERMISSIONDATA?.category?.request === 'Y' || 
            PERMISSIONDATA?.category?.service === 'Y' ||
            user?.admin_type === 'Super Admin') && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <TbCategory className="sidebar_collapse_iohomeoutline" />
                      <span
                        className={`sidebar_collapse_iohomeoutline_categoires ${
                          isOpen ? "visible" : "hidden"
                        }`}
                      >
                        Categories
                      </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${
                    isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
                >
                  {(PERMISSIONDATA?.category?.product === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/categories/product/list" icon={<TbPointFilled />} name="Products" isOpen={isOpen}/>
                  )}
                  {(PERMISSIONDATA?.category?.service === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/categories/service/list" icon={<TbPointFilled />} name="Services" isOpen={isOpen} />
                  )}
                  {(PERMISSIONDATA?.category?.service === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/categories/request/list" icon={<TbPointFilled />} name="Request" isOpen={isOpen} />
                  )}
                </Panel>
              </Collapse>
            </React.Fragment>
          )} */}

          {( user?.admin_type === 'Super Admin'
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <TbCategory className="sidebar_collapse_iohomeoutline" />
                      <span
                        className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >CMS</span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${
                    isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
                >
                  {(PERMISSIONDATA?.cms?.term_condition === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/cms/term-condition" icon={<TbPointFilled />} name="Terms And Conditions" isOpen={isOpen} />
                  )}
                  {(PERMISSIONDATA?.cms?.provacyPolicy === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/cms/privacy-policy" icon={<TbPointFilled />} name="Privacy Policy" isOpen={isOpen} />
                  )}
                  {(PERMISSIONDATA?.cms?.generalData === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/cms/general-data" icon={<TbPointFilled />} name="General Data" isOpen={isOpen} />
                  )}
                  {(PERMISSIONDATA?.cms?.emailTemplates === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/cms/email-templates" icon={<TbPointFilled />} name="Email Templates" isOpen={isOpen} />
                  )}
                  {(PERMISSIONDATA?.cms?.ticker === 'Y' || user?.admin_type === 'Super Admin') && (
                    <SidebarItem to="/cms/ticker-data" icon={<TbPointFilled />} name="Ticker" isOpen={isOpen} />
                  )}
              </Panel>
              </Collapse>
            </React.Fragment>
          )}
          {(PERMISSIONDATA?.orders?.orders === 'Y' || user?.admin_type === 'Super Admin') && (
            <SidebarItem
              to="/speakers/list"
              icon={<CiShoppingBasket />}
              name="Speakers"
              isOpen={isOpen}
            />
          )}
          {(PERMISSIONDATA?.orders?.orders === 'Y' || user?.admin_type === 'Super Admin') && (
            <SidebarItem
              to="/trainings/list"
              icon={<CiShoppingBasket />}
              name="Trainings"
              isOpen={isOpen}
            />
          )}
          {(PERMISSIONDATA?.orders?.orders === 'Y' || user?.admin_type === 'Super Admin') && (
            <SidebarItem
              to="/orders/list"
              icon={<CiShoppingBasket />}
              name="Orders"
              isOpen={isOpen}
            />
          )}

          {/* <SidebarItem to="/service/list" icon={<MdOutlineInventory2 />} name="Services" isOpen={isOpen} /> */}

          {/* <SidebarItem to="/bookings/list" icon={<CiShoppingBasket />} name="Bookings" isOpen={isOpen} /> */}

          <SidebarItem to="/payments" icon={<MdOutlinePayment />} name="Payments" isOpen={isOpen} />
          <SidebarItem to="/coupons/list" icon={<MdOutlinePayment />} name="Coupons" isOpen={isOpen} />
          {( user?.admin_type === 'Super Admin'
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <TbCategory className="sidebar_collapse_iohomeoutline" />
                      <span
                        className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`} >Forms</span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${
                    isOpen ? "arrow-visible" : "arrow-hidden"
                  }`}
                >
                  <SidebarItem to="/form/contact" icon={<TbPointFilled />} name="Contact" isOpen={isOpen} />
                  <SidebarItem to="/form/newsletter" icon={<TbPointFilled />} name="Newsletter" isOpen={isOpen} />
              </Panel>
              </Collapse>
            </React.Fragment>
          )}

          {/*<SidebarItem
            to="/promtotions"
            icon={<CiDiscount1 />}
            name="Promotion"
            isOpen={isOpen}
          />*/}
          {/* <React.Fragment>
            <SidebarItem
              icon={
                <img
                  src={
                    user?.admin_image
                      ? ASSETS_BASE_URL + user.admin_image
                      : ""
                  }
                  alt=""
                  className="user_profile_pic_sidebar"
                  onClick={handleCollapseToggle}
                  width="100px"
                />
              }
              to="/profile"
              name={
                <div className="sidebar_profile_main_content_section">
                  <React.Fragment>
                    <div className="sidebar_profile_main_content">
                      <div className="user_profile_pic_Admin_name">
                        <span className="user_profile_pic_Admin_panel">
                          {`${user?.admin_first_name} ${user?.admin_last_name}`}
                        </span>{" "}
                        <br />
                        <span className="user_profile_pic_Admin_panel_">
                          Admin
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                  <React.Fragment>
                    <FaGreaterThan
                      className="side_bar_fagreaterthan"
                      onClick={handleCollapseToggle}
                    />
                  </React.Fragment>
                </div>
              }
              isOpen={isOpen}
              className="custom_profile_class"
            >
            </SidebarItem>
          </React.Fragment> */}
        </div>
      </div>
      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
